import script from "./BaseCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseCheckbox.vue?vue&type=script&lang=ts&setup=true"

import "./BaseCheckbox.vue?vue&type=style&index=0&id=26043558&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26043558"]])

export default __exports__